import * as React from 'react';
import { CheckMarkIcon } from '../../../components/Icons/CheckMarkIcon';
import {
    CheckmarkList,
    CheckmarkListItem,
    CheckmarkListItemIcon,
    CheckmarkListItemText,
} from '../../../components/CheckmarkList/CheckmarkList';
import { __ } from '../../../helpers/TranslationService';
import { ICruiseIconOption } from '../../../interfaces';

interface IInclusivesList {
    icons: {
        icon: ICruiseIconOption;
        text: string;
    }[];
}
const CruiseStageInclusivesList = ({ icons }: IInclusivesList) => {
    return (
        <CheckmarkList>
            {icons.map((icon, i) => (
                <CheckmarkListItem key={`inclusive-${i}`}>
                    <CheckmarkListItemIcon />
                    <CheckmarkListItemText>{__(icon?.text, 'dreamlines')}</CheckmarkListItemText>
                </CheckmarkListItem>
            ))}
        </CheckmarkList>
    );
};
export default CruiseStageInclusivesList;
